/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorChangeDayCount } from './ActorChangeDayCount';
import {
    ActorChangeDayCountFromJSON,
    ActorChangeDayCountFromJSONTyped,
    ActorChangeDayCountToJSON,
    ActorChangeDayCountToJSONTyped,
} from './ActorChangeDayCount';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface ActorChangeHistoryMonth
 */
export interface ActorChangeHistoryMonth {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof ActorChangeHistoryMonth
     */
    userId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof ActorChangeHistoryMonth
     */
    year: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof ActorChangeHistoryMonth
     */
    month: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {Array<ActorChangeDayCount>}
     * @memberof ActorChangeHistoryMonth
     */
    days: Array<ActorChangeDayCount>;
}

/**
 * Check if a given object implements the ActorChangeHistoryMonth interface.
 */
export function instanceOfActorChangeHistoryMonth(value: object): value is ActorChangeHistoryMonth {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('year' in value) || value['year'] === undefined) return false;
    if (!('month' in value) || value['month'] === undefined) return false;
    if (!('days' in value) || value['days'] === undefined) return false;
    return true;
}

export function ActorChangeHistoryMonthFromJSON(json: any): ActorChangeHistoryMonth {
    return ActorChangeHistoryMonthFromJSONTyped(json, false);
}

export function ActorChangeHistoryMonthFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActorChangeHistoryMonth {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': ApiUserTasksGetPageParameterFromJSON(json['userId']),
        'year': ApiUserTasksGetPageParameterFromJSON(json['year']),
        'month': ApiUserTasksGetPageParameterFromJSON(json['month']),
        'days': ((json['days'] as Array<any>).map(ActorChangeDayCountFromJSON)),
    };
}

export function ActorChangeHistoryMonthToJSON(json: any): ActorChangeHistoryMonth {
    return ActorChangeHistoryMonthToJSONTyped(json, false);
}

export function ActorChangeHistoryMonthToJSONTyped(value?: ActorChangeHistoryMonth | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': ApiUserTasksGetPageParameterToJSON(value['userId']),
        'year': ApiUserTasksGetPageParameterToJSON(value['year']),
        'month': ApiUserTasksGetPageParameterToJSON(value['month']),
        'days': ((value['days'] as Array<any>).map(ActorChangeDayCountToJSON)),
    };
}

